import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-point",
  "use": "icon-point-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-point\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 788.45226537a276.45226537 276.45226537 0 1 0 0-552.90453074 276.45226537 276.45226537 0 0 0 0 552.90453074z\" p-id=\"969\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol